<div class="flex flex-col gap-y-[2px]">
  <span class="text-blue-gray-500 text-[12px] leading-[20px] tracking-[0.2px]">{{ label }}</span>
  <ng-content></ng-content>
</div>
